import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function usePModelList(id, params) {
  return useSWR(
    {
      path: `/api/v1/products/${id}/product-models`,
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default usePModelList;
